import styled from 'styled-components'

import { getStateColor } from '@/presentation/utils'
import { appZIndex } from '@/presentation/utils/zIndexMapper'

export const NewsBannerContainer = styled.div`
  z-index: ${appZIndex.BANNER_DESKTOP};
  width: 100%;
  max-width: 654px;
  height: 391px;
  border-radius: 10px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: ${({ theme }) => theme.colors.neutralL5};

  & * {
    user-select: text;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Box = styled.div`
  width: 48px;
  height: 32px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 10px 0px 0px 0px;
`

export const CloseButton = styled.button`
  margin: 16px 16px 0 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralL4};
  }
`

export const Body = styled.div`
  display: flex;
  padding: 0 48px;
  gap: 20px;
  align-items: center;
`

export const Title = styled.h2`
  ${({ theme }) => theme.fonts.h4}
  color: ${({ theme }) => theme.colors.secondaryD3};
  padding-bottom: 14px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  gap: 10px;

  & > p,
  li {
    ${({ theme }) => theme.fonts.textSM}
    color: ${({ theme }) => theme.colors.secondaryD3};

    & > strong {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.secondaryD3};
    }
  }
`

export const StepsContainer = styled.ul`
  margin: 0;
  padding-left: 20px;
`

export const StepItem = styled.li`
  color: ${({ theme }) => theme.colors.secondaryD3};
  & > strong {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.secondaryD3};
  }
`

export const BannerActionButton = styled.button`
  align-self: center;
  width: fit-content;
  padding: 10px 19px;
  text-align: center;
  cursor: pointer;
  border: none;
  border-radius: 25px;
  background: ${({ theme }) => theme.colors.secondaryD1};
  ${({ theme }) => theme.fonts.titleXS}

  &:hover {
    transition: background-color 0.1s;
    background-color: ${({ theme }) => getStateColor(theme.colors.secondaryD1, 'hover')};
  }
`
